module.exports = __webpack_public_path__ + "img/idu8w-bah1n.583c56f1.png";